import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function createAccessory(data) {
    return HttpService.post('/v1/accessories', data);
}

export async function updateAccessory(data) {
    const { id } = data;
    delete data.id;
    return HttpService.put('/v1/accessories/' + id, data);
}

export async function removeAccessory(accessoryId) {
    return HttpService.delete('/v1/accessories/' + accessoryId);
}

export async function loadAccessories(projectId) {
    return HttpService.get('/v1/accessories', { projectId });
}

// TYPES

export async function createAccessoryType(data) {
    return HttpService.post('/v1/accessories/types', data);
}

export async function updateAccessoryType(data) {
    const { id } = data;
    delete data.id;
    return HttpService.put('/v1/accessories/types/' + id, data);
}

export async function removeAccessoryType(accessoryTypeId) {
    return HttpService.delete('/v1/accessories/types/' + accessoryTypeId);
}

export async function loadAccessoriesTypes(projectId) {
    return HttpService.get('/v1/accessories/types', { projectId });
}
